import { CheckIcon, ChevronDown } from 'lucide-react'

import { CommandItem } from '../command/Command'
import { cn } from '../lib/cn'

type Option = {
  label?: string
  value?: string
  icon?: React.ComponentType<{ className?: string }>
}

export type Options = Array<Option>

export interface BaseSelectProps {
  options: Options
  placeholder?: string
  disabled?: boolean
  /*
    Fix issue with scrollbar when MultiSelect is used in a modal or Popover.
    Original example: https://github.com/sersavan/shadcn-multi-select-component/blob/main/src/components/multi-select.tsx
  */
  modal?: boolean
  /*
    CustomFirstOptions to render first custom options that is not in the options array.
  */
  CustomFirstOptions?: React.ComponentType<{
    options: Options
    value: string[]
    toggleValue: (val: string) => void
    onlyOneSelect: boolean
  }>
}

const CheckIconComponent = ({ isSelected }: { isSelected: boolean }) => (
  <div
    className={cn(
      'mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary',
      isSelected ? 'bg-primary text-primary-foreground' : 'opacity-50 [&_svg]:invisible',
    )}
  >
    <CheckIcon className='h-4 w-4 text-card' />
  </div>
)

export const MSItemComponent = ({
  value = [],
  onlyOneSelect = false,
  toggleValue = () => {},
  option = { value: '-', label: '-' },
}: {
  name?: string
  value: string | string[] | null
  onlyOneSelect: boolean
  toggleValue: (name: string) => void
  option: Option
}) => {
  const name = option.value || '-'
  const isSelected = onlyOneSelect ? value === name : Array.isArray(value) && value.includes(name)

  return (
    <CommandItem key={name} value={name} keywords={[String(option.label) || '']} onSelect={() => toggleValue(name)}>
      {!onlyOneSelect && <CheckIconComponent isSelected={isSelected} />}
      {option.icon && <option.icon className='mr-2 h-4 w-4 text-muted-foreground' />}
      <span className={cn('flex-1 truncate', onlyOneSelect && isSelected && 'font-medium')}>{option.label}</span>
      {/* Single select: check sits on the right in a fixed slot, so labels never shift. */}
      {onlyOneSelect && <CheckIcon className={cn('ml-2 size-4 shrink-0 text-primary', !isSelected && 'invisible')} />}
    </CommandItem>
  )
}

export const ChevronIcon = ({ open }: { open: boolean }) => (
  <ChevronDown className={cn('h-4 cursor-pointer text-muted-foreground', open && 'rotate-180')} />
)
